<template>
  <div class="sr-property">
    <div class="gallery">
      <sr-thumb-zoom :list="DATA.info.shopImages"/>
    </div>
    <div class="wrap">
      <p class="shopName">{{DATA.info.shopName}}</p>
      <p class="avgCount"><span>{{DATA.info.avgCount | money}}</span> / 人均</p>
      <p class="address">地址：{{DATA.info.address}}</p>
      <p class="reservationCall">电话：{{DATA.info.reservationCall}}</p>
      <p class="storeInfo">简介：{{DATA.info.storeInfo}}</p>
      <div class="reminder" v-if="DATA.info.reminder">
        <p>温馨提示：</p>
        <div v-html="DATA.info.reminder"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import SrThumbZoom from '@/components/thumb-zoom'
  export default {
    components: {
      SrThumbZoom
    },
    props: {
      data: Object
    },
    data () {
      return {
        DATA: this.data
      }
    }
  }
</script>

<style lang="less" scoped>
  .sr-property {
    overflow: hidden;
    padding: 30px 0;
    .gallery {
      float: left;
      width: 684px;
      overflow: hidden;
    }
    .wrap {
      float: right;
      width: 460px;
      .brand {
        color: #333;
      }
      .shopName {
        padding: 10px 0;
        font-size: 20px;
        font-weight: bold;
        color: #333;
      }
      .avgCount {
        color: #cdad66;
        span {
          font-weight: bold;
          font-size: 16px;
        }
      }
      .address{
        padding-top: 10px;
      }
      .reservationCall {
        padding-top: 10px;
      }
      .storeInfo {
        padding-top: 10px;
      }
      .reminder {
        padding-top: 10px;
      }
    }
    .dialog-con {
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/restaurant-detail/sr-top.vue